import React from 'react';
import PropTypes from 'prop-types';

import MonthDropdown from '../../MonthDropdown';
import SimpleDropdown from '../../Dropdowns/SimpleDropdown';
import { format, subDays, subMonths, toJSDate } from '../../../utils/date';

const YearMonthForm = ({
  date,
  frameless,
  fromMonth,
  toMonth,
  forwardedRef,
  onChange,
  onMenuClose,
}) => {
  const fromYear = fromMonth.getFullYear();
  const toYear = toMonth.getFullYear();
  const dateYear = date.getFullYear();

  const startOfMonth = (monthDate) => {
    const newDate = toJSDate(monthDate);
    return subDays(newDate, newDate.getDate() - 1);
  };

  const monthsCountFromEndMonth = () => (toYear - dateYear - 1) * 12 + (toMonth.getMonth() + 1);

  let startMonth = startOfMonth(toMonth);
  let monthsCount = 1;

  // Months, available for selection during selected year
  if (fromYear === toYear) {
    monthsCount = toMonth.getMonth() - fromMonth.getMonth() + 1;
  }
  if (fromYear !== toYear) {
    if (dateYear === toYear) {
      monthsCount = toMonth.getMonth() + 1;
    }
    if (dateYear === fromYear) {
      startMonth = startOfMonth(subMonths(toMonth, monthsCountFromEndMonth()));
      monthsCount = 12 - (fromMonth.getMonth() + 1);
    }
    if (dateYear > fromYear && dateYear < toYear) {
      startMonth = startOfMonth(subMonths(toMonth, monthsCountFromEndMonth()));
      monthsCount = 12;
    }
  }

  const availableYears = [];

  for (let i = fromYear; i <= toYear; i += 1) {
    availableYears.push({
      value: i,
      label: i.toString(),
    });
  }

  const handleDateChange = (year, month) => {
    const hours = new Date().getHours();
    const minutes = new Date().getMinutes();

    onChange(new Date(year, month, 1, hours, minutes));
  };

  const handleMonthChange = (value) => {
    handleDateChange(dateYear, toJSDate(value).getMonth());
  };

  const handleYearChange = (year) => {
    handleDateChange(year, date.getMonth());
  };

  const handleMenuChange = ({ open }) => {
    if (!open) onMenuClose();
  };

  return (
    <div className="DayPicker-Caption" ref={forwardedRef}>
      <div className="d-contents ignore-focus">
        <MonthDropdown
          current={date}
          start={startMonth}
          monthsCount={monthsCount}
          monthOnly
          naturalOrder
          menuAlign="start"
          menuWidth={160}
          caret
          portal={false}
          frameless={frameless}
          unselectedStateText={format(date, 'MMMM')}
          onChange={handleMonthChange}
          onMenuChange={handleMenuChange}
        />
        <SimpleDropdown
          selected={dateYear}
          options={availableYears}
          frameless={frameless}
          unselectedStateText={dateYear.toString()}
          menuWidth={120}
          portal={false}
          onChange={handleYearChange}
          onMenuChange={handleMenuChange}
        />
      </div>
    </div>
  );
};

YearMonthForm.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  fromMonth: PropTypes.instanceOf(Date).isRequired,
  toMonth: PropTypes.instanceOf(Date).isRequired,
  frameless: PropTypes.bool,
  forwardedRef: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onMenuClose: PropTypes.func.isRequired,
};

export default YearMonthForm;
